import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { NYCPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: " How can custom software development help my business?",
    answer: `<p>The software development industry has taken the world by storm and for all the right reasons. Like countless enterprises, mid-market, small businesses, and startups, custom software development services by any experienced custom software development company can help your business grow at an unprecedented rate.</p>
        <p>From eliminating inefficiencies in your business process to creating new channels and mediums for revenue to ensuring a comprehensive and transparent process for internal and external communications and managing your productivity to enabling quick revenue growth – software development can help your business grow in numerous ways.</p>`,
  },
  {
    question: " Do you offer post delivery maintenance services?",
    answer: ` <p>Yes, we do offer post delivery maintenance services to our clients. They can always call us, or draft an email with their concerns.</p>`,
  },
  {
    question:
      "Do you provide product support services after the software development is complete?",
    answer: `<p>Yes, we do. TekRevol is a full-cycle digital transformation and custom software development company that has worked with 500+ enterprise, mid-market, and small businesses and enabled several startups to develop and expand their digital footprint. Over the years, we have continued to serve multiple organizations by providing them with post-development and post-launch product support services to keep them running smoothly. TekRevol takes care of all the factors of the product – whether there is a development need or it is about hosting it on the cloud or on legacy servers – we have got our clients covered</p>`,
  },
  {
    question:
      " Do I need an iOS app or an Android app? Which platform is better to start with?",
    answer: `<p>To choose between an iOS or Android app, you first need to have a look at multiple factors, and then you can decide which platform might be the most suitable for your business. There are certain pros and cons of each platform, and there is a clear difference in the audience of Android and iOS users. Moreover, it is comparatively easier to hire Android app developers for Android app development services. When it comes to performance, there is no such difference in both – but there are a few exceptions. Also, you can choose to build your app on both platforms if your audience is scattered. It can, only after careful analysis, be decided which of the two platforms is more suitable to get started.</p>`,
  },
  {
    question: " What information do you need from me to start work?",
    answer: `<p>To start working on your project, we may ask a series of questions that can vary depending on your project requirements, its scope, the scale, and the timelines – including the target market as well. To build a market-ready application, it has to have all the prerequisites and the information – but that is up to our experts and project managers to collect. All you have to do is review the progress and share insights where you feel we might not be doing what you need. Once we have all the information and it gets documented, we begin with our custom software development process. Phase by phase, we build your product or software as per modern standards so that you get the finest quality in the end.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{NYCPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
